var map = {
	"./music-instructions.json": 4592,
	"./music-library-intro2024.json": 4593,
	"./music-library-launch2024.json": 4594,
	"./music-progression.json": 4595,
	"./startSourcesAdvanced.json": 4596,
	"./startSourcesSimple.json": 4597,
	"./startSourcesSimple2.json": 4598,
	"./startSourcesTracks.json": 4599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4361;